// extracted by mini-css-extract-plugin
export var fullWidthButton = "_zo-0";
export var tagInputDisabled = "_zo-1";